import React from "react";
import {useNavigate} from "react-router-dom";
import {Avatar, Button, Dropdown} from "antd";
import {CaretDownOutlined} from "@ant-design/icons";

import {useAppSelector} from "../hooks/useStore";
import {selectCurrentInitials, selectIsStaff} from "../store/slices/userSlice";

import {orange} from "../assets/colors";

const HeaderDropdown = () => {
    const navigate = useNavigate();

    const isStaff = useAppSelector(selectIsStaff);
    const profilesCount = useAppSelector(state => state.user.profiles).length;
    const initials = useAppSelector(selectCurrentInitials);

    const items = [
        {
            label: <Button type="link" onClick={() => navigate('/logout')} danger htmlType="button">Log Out</Button>,
            key: 1,
        }
    ];

    const changeProfileJSX =
        {
            label: (
                <div onClick={() => navigate('/profile_change')}>
                    Change Profile
                </div>
            ),
            key: 2,
        };

    if (!isStaff && profilesCount > 1) {
        items.splice(0, 0, changeProfileJSX);
    }

    return (
        <Dropdown trigger={["click"]} menu={{items}}>
            <Button type="link" style={{height: '100%'}}>
                <Avatar style={{backgroundColor: orange}}>
                    {initials}
                </Avatar>
                <CaretDownOutlined/>
            </Button>
        </Dropdown>
    )
};

export default HeaderDropdown;
